export default {
  defaultPhotoFilename: 'default.jpg',
  productSiteAssetsUrl: 'https://s3-us-west-2.amazonaws.com/cargomatic-product-site/assets/images',
};
